import { Button, Flex, Typography } from 'antd';
import { useCallback, useRef, useState } from 'react';
import { PreSalesHandoverType, SalesChannel, Slot } from '../../../dto/model';
import { strings } from '../../../lang';
import { SalesCallCalendar } from '../../appointment-booking/sales-call-calendar';
import { fireBookingConfetti } from '../booking-confetti';
import { PreSalesBookingSuccess } from './pre-sales-booking-success';
import { PreSalesQuestionnaireCard } from './pre-sales-questionnaire-card';

type PreSalesPvForwardingResultProps = {
  signupId: string;
  handoverType: PreSalesHandoverType;
  onBooked?: () => void;
  onBackToForm: () => void;
};

export const PreSalesPvForwardingResult = ({
  signupId,
  handoverType,
  onBooked,
  onBackToForm,
}: PreSalesPvForwardingResultProps) => {
  const [bookedSlot, setBookedSlot] = useState<Slot | null>(null);
  const hasHandledBookingRef = useRef(false);
  const isPvHandover = handoverType === 'hp_to_pv';

  const handleBooking = useCallback((isSuccess: boolean, slot?: Slot) => {
    if (!isSuccess || !slot || hasHandledBookingRef.current) return;

    hasHandledBookingRef.current = true;
    setBookedSlot(slot);
    fireBookingConfetti();
    onBooked?.();
  }, [onBooked]);

  return (
    <PreSalesQuestionnaireCard
      isResult
      footer={(
        <Button onClick={onBackToForm}>
          {strings.preSalesQuestionnaire.backToFormButton}
        </Button>
      )}
    >
      {bookedSlot ? (
        <PreSalesBookingSuccess
          bookedSlot={bookedSlot}
          title={isPvHandover
            ? strings.preSalesQuestionnaire.pvBookingSuccessTitle
            : strings.preSalesQuestionnaire.combiBookingSuccessTitle}
        />
      ) : (
        <Flex vertical gap={16} className="bp-presales-result-calendar">
          <Typography.Title level={4} style={{ margin: 0 }}>
            {isPvHandover
              ? strings.preSalesQuestionnaire.pvForwardingSuccessTitle
              : strings.preSalesQuestionnaire.combiForwardingSuccessTitle}
          </Typography.Title>
          <Typography.Paragraph style={{ margin: 0 }}>
            {isPvHandover
              ? strings.preSalesQuestionnaire.pvHandoverCalendarDescription
              : strings.preSalesQuestionnaire.combiHandoverCalendarDescription}
          </Typography.Paragraph>
          <SalesCallCalendar
            opportunityId=""
            signupId={signupId}
            sourceSystemHeader="presales-pv-handover"
            salesChannel={SalesChannel.DigitalSales}
            retryInitialLoad
            skipConfirmationAfterBooking
            onBooking={handleBooking}
          />
        </Flex>
      )}
    </PreSalesQuestionnaireCard>
  );
};
